import { apiClient } from "../client";
import type { IncompleteProfilesResponse, ProfileGap } from "../../types/incompleteProfile";

export const incompleteProfilesService = {
  getIncompleteProfiles: async (params: {
    page?: number;
    limit?: number;
    search?: string;
    missing?: ProfileGap;
    schoolId?: string;
    campusId?: string;
  }): Promise<IncompleteProfilesResponse> => {
    const query = new URLSearchParams();

    if (params.page) query.append("page", params.page.toString());
    if (params.limit) query.append("limit", params.limit.toString());
    if (params.search) query.append("search", params.search);
    if (params.missing) query.append("missing", params.missing);
    if (params.schoolId) query.append("school_id", params.schoolId);
    if (params.campusId) query.append("campus_id", params.campusId);

    const response = await apiClient.get(`/api/admin/users/incomplete?${query.toString()}`);
    return response.data;
  },
};
